import React from 'react';

export default function Header({ title, left, right }) {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 100,
      padding: '14px 20px',
      paddingTop: 'calc(var(--tg-safe-top, 0px) + 14px)',
      display: 'flex', alignItems: 'center', justifyContent: (left || right) ? 'space-between' : 'center',
      background: 'rgba(10,10,10,0.85)',
      backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
      borderBottom: '1px solid var(--border)',
    }}>
      {left || (right && <div style={{ minWidth: 50 }}></div>)}
      <div style={{ fontSize: 17, fontWeight: 700, letterSpacing: -0.4 }}>{title}</div>
      {right || (left && <div style={{ minWidth: 50 }}></div>)}
    </div>
  );
}
